import { render, staticRenderFns } from "./3-1.E-Review.vue?vue&type=template&id=35f6b6c2&scoped=true"
import script from "./3-1.E-Review.vue?vue&type=script&lang=js"
export * from "./3-1.E-Review.vue?vue&type=script&lang=js"
import style0 from "./3-1.E-Review.vue?vue&type=style&index=0&id=35f6b6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6b6c2",
  null
  
)

export default component.exports